import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormlyFillHeightListHostDirective } from '../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { WidgetProductListComponent } from '../product-list-widget/product-list-widget.component';

@Component({
    selector: 'app-formly-product-group-product-list',
    templateUrl: './formly-product-group-product-list.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [FormlyFillHeightListHostDirective],
    imports: [TranslatePipe, WidgetProductListComponent],
})
export class FormlyProductGroupProductListComponent extends FieldType {
}
